const initialState = {
  city: "",
  state: "AL",
  searchKeyword: "",
  scraper: "zillow",
  maxNumber: 0,
  searchResults: [],
  isScraping: false,
  totalItemNumber: 0,
  totalPages: 0,
  currentPage: 1,
  currentItems: [],
  appealsLost: 0,
  appealsWon: 0,
  approvedClaims: 0,
  averageCashSettlement: 0,
  averageTimeToClose: 0,
  eggsHatchedThisMonth: 0,
  successRate: 0,
  totalCashSettlement: 0,
  deniedClaims: 0,
  totalCounts: 0,
  totalPoints: 0,
  totalEggsHatchedThisMonth: 0,
  claimsData: [],
  badgeData: [],
  setAudio: 0,
  setReferralAudio: 0,
  setGoogleReviewAudio: 0,
  setActionAutio: 0,
  setAudioOh: 0,
  setGift: 0,
  setNoGift: 0,
  setCatGift: 0,
  leaderboard: [],
  symbol: "",
  badgegif: "",
  isNo: 0,
  setAudioAFCA: 0,
  googleReviewNumber: 0,
  hideShowFinishedClaims: true,
  afcaClaimDenied:0,
  totalAuthorized:0,
  underAssessment:0,
  appealInProgress:0,
  AFCAAppeal:0,
  scopeOfWorks:0,
  AFCASOW:0,
  cashSettlement:0,
  variation:0,
  childClaimDeclined:0,
  userNames: [],
  showClaim: false,
  role: 0,
  googleReviews: [],
  referrals: [],
  breachs: [],
  currentUserName: "",
  learnerBadge: false,
  afcaWarrior: false,
  afcaGeneral: false,
  firstThreat: false,
  clubAudio: "",
};

const reducer = (state = initialState, action) => {
  // const newState = { ...state };
  switch (action.type) {
    case "SET_CITY":
      return { ...state, city: action.payload };
    case "SET_STATE":
      return { ...state, state: action.payload };
    case "SET_SEARCH_KEYWORD":
      return { ...state, searchKeyword: action.payload };
    case "SET_MAX_NUMBER":
      return { ...state, maxNumber: action.payload };
    case "SET_SCRAPER":
      return { ...state, scraper: action.payload };
    case "SEARCH_SUCCESS":
      return { ...state, searchResults: action.payload, isScraping: false };
    case "SET_SCRAPING":
      return { ...state, isScraping: true };
    case "STOP_LOADING":
      return { ...state, isScraping: false };
    case "SET_TOTAL_ITEM_NUMBER":
      return { ...state, totalItemNumber: action.payload };
    case "SET_TOTAL_PAGES":
      return { ...state, totalPages: action.payload };
    case "INCREMENT_PAGE":
      return { ...state, currentPage: state.currentPage + 1 };
    case "REDUCE_PAGE":
      return { ...state, currentPage: state.currentPage - 1 };
    case "SET_CURRENT_ITEMS":
      return { ...state, currentItems: action.payload };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "GET_ALL_VALUES":
      return {
        ...state,
        appealsLost: action.payload.appealsLost,
        appealsWon: action.payload.appealsWon,
        approvedClaims: action.payload.approvedClaims,
        averageCashSettlement: action.payload.averageCashSettlement,
        averageTimeToClose: action.payload.averageTimeToClose,
        eggsHatchedThisMonth: action.payload.eggsHatchedThisMonth,
        successRate: action.payload.successRate,
        totalCashSettlement: action.payload.totalCashSettlements,
        deniedClaims: action.payload.deniedClaims,
        totalCounts: action.payload.totalCounts,
        totalPoints: action.payload.totalPoints,
        totalEggsHatchedThisMonth: action.payload.totalEggsHatchedThisMonth,
        googleReviewNumber: action.payload.googleReview,
        afcaClaimDenied: action.payload.afcaClaimDenied,
        totalAuthorized: action.payload.totalAuthorized,
        underAssessment: action.payload.underAssessment,
        appealInProgress: action.payload.appealInProgress,
        AFCAAppeal: action.payload.AFCAAppeal,
        scopeOfWorks: action.payload.scopeOfWorks,
        AFCASOW: action.payload.AFCASOW,
        cashSettlement: action.payload.cashSettlement,
        variation: action.payload.variation,
        childClaimDeclined: action.payload.childClaimDeclined,
        userNames: action.payload.userNames,
        role: action.payload.role,
      };
    case "GET_ALL_REVIEW_DATA":
      return {
        ...state,
        googleReviews: action.payload.googleReviewData,
        referrals: action.payload.referralData,
        breachs: action.payload.breachData,
      }
    case "GET_ALL_CLAIMS":
      return { ...state, claimsData: action.payload };
    case "GET_ALL_BADGE":
      return { ...state, badgeData: action.payload };
    case "SET_AUDIO":
      return { ...state, setAudio: state.setAudio + 1 };
    case "SET_REFERRAL_AUDIO":
      return { ...state, setReferralAudio: state.setReferralAudio + 1 };
    case "SET_CLUB_AUDIO":
      return { ...state, clubAudio: action.payload };
    case "SET_GOOGLE_REVIEW_AUDIO":
      return { ...state, setGoogleReviewAudio: state.setGoogleReviewAudio + 1 };
    case "SHOW_CLAIM":
      return { ...state, showClaim: true };
    case "SET_CURRENT_USERNAME":
      return { ...state, currentUserName: action.payload };
    case "HIDE_CLAIM":
      return { ...state, showClaim: false };
    case "SET_FIRST_THREAT": 
      return { ...state, firstThreat: true };
    case "SET_AUDIO_OH":
      return { ...state, setAudioOh: state.setAudioOh + 1}
    case "SET_ACTION_AUDIO":
      return { ...state, setActionAutio: state.setActionAutio + 1 };
    case "SET_GIFT":
      return { ...state, setGift: state.setGift + 1, isNo: state.isNo + 1 };
    case "SET_AFCA_WARRIOR":
      return { ...state, afcaWarrior: true};
    case "SET_AFCA_GENERAL":
      return { ...state, afcaGeneral: true};
    case "SET_LEADERS":
      return { ...state, leaderboard: action.payload };
    case "SET_SYMBOL":
      return { ...state, symbol: action.payload };
    case "SET_LEANER_BADGE":
      return { ...state, learnerBadge: true };
    case "SET_NO_GIFT":
      return { ...state, setNoGift: state.setNoGift + 1, isNo: 0, badgegif: "Nooo!" };
    case "SET_CAT_GIFT":
      return { ...state, setCatGift: state.setCatGift + 1, isNo: state.isNo + 1, badgegif: action.payload };
    case "SET_BADGE_GIFT":
      return { ...state, badgegif: action.payload, isNo: state.isNo + 1  };
    case "SET_AUDIO_AFCA":
      return { ...state, setAudioAFCA: state.setAudioAFCA + 1 };
    case "HIDE_SHOW_FINISHED_CLAIMS":
      return { ...state, hideShowFinishedClaims: !state.hideShowFinishedClaims  };
    default:
      return state;
  }
};

export default reducer;
